import numeral from 'numeral';

// Poor-mans regular expression escape'er
const escape = (symbol: string) => {
    switch (symbol) {
        case '.':
            return '\\.';
        default:
            return symbol;
    }
};

export const parseDecimalToFloat = (str?: number | string): number | null => {
    if (!str) {
        return null;
    }

    if (typeof str === 'number') {
        return str;
    }

    const delimiters = (numeral as any).localeData().delimiters;
    const floatStr = str.replace(new RegExp(escape(delimiters.thousands), 'g'), '').replace(delimiters.decimal, '.');
    const float = parseFloat(floatStr);
    return isNaN(float) ? null : float;
};

/**
 * Formats a number for display in forms using the current locale's decimal delimiter
 * This is the counterpart to parseDecimalToFloat - use this when displaying database values in forms
 *
 * @param value - The value to format (from database, always uses dot as decimal)
 * @param decimalPlaces - Number of decimal places to show (default: 2)
 * @returns Formatted string using locale-specific decimal delimiter
 *
 * @example
 * // For German locale (de_DE):
 * formatFloatForDisplay("123.45") // returns "123,45"
 * formatFloatForDisplay("123.45", 0) // returns "123"
 *
 * // For English locale (en_GB):
 * formatFloatForDisplay("123.45") // returns "123.45"
 */
export const formatFloatForDisplay = (value?: string | number | null, decimalPlaces: number = 2) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    // Convert string to number if needed
    const num = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(num)) {
        return '';
    }

    // Create format string with thousands separators and decimal places
    const formatString = decimalPlaces > 0 ? `0,0.${'0'.repeat(decimalPlaces)}` : '0,0';

    return numeral(num).format(formatString);
};

export const isNumber = (n: any) => {
    const parsedNumber = parseFloat(n);
    return n !== null && !isNaN(parsedNumber);
};
